import { formatDateForCheckingState } from './dateFormatters';

export const formatFundUrl = (
  url: string,
  fundId: string,
  positionDate?: string | undefined,
) => {
  return positionDate
    ? url + '/' + fundId + '/' + positionDate
    : url + '/' + fundId;
};

/**
 * Append `page_name` so the API can select the response model for the requesting page.
 * Preserves any existing query string.
 */
export const appendPageNameQueryParam = (
  url: string,
  pageName: string,
): string => {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}page_name=${encodeURIComponent(pageName)}`;
};

export const makeUniqueDataKey = (
  fundName: string,
  keyName: string,
  positionDate: string | undefined = undefined,
) => {
  return positionDate
    ? `${positionDate}_${fundName}_${keyName}`
    : `${fundName}_${formatDateForCheckingState(new Date())}_${keyName}`;
};
